// staleTime — BE 캐시 갱신 주기. 훅과 일반 함수(v2CommonApi.ts)가 같은 queryKey 를 공유하므로 같은 값을 써야 한다.
export const FEATURE_FLAG_STALE_TIME = 30_000
